import { BrowserRouter, Route, Routes } from "react-router-dom";
import FrontPage from "./pages/LandingPage";
import ParentLogin from "./pages/LoginPage";
import Signup from "./pages/SignupPage";
import OtpVerify from "./pages/OtpPage";
import Verify from "./components/Verify";
import LanguageState from "./context/language/LanguageState";
import Profile from "./pages/ProfilePage";
import QuestionPage from "./pages/QuestionPage";
import SessionTimeoutPopup from "./components/Session";
import Alert from "./components/Alert";
import MedicineChatBot from "./components/MedicineChatBot";
import PatientSummaryEntry from "./components/PatientSummaryEntry";
import WardenStudentDashboard from "./components/NursePatientDashboard";
import ChatHistory from "./components/ChatHistory";
import ViewAppointments from "./components/ViewAppointments";
import ViewLabTests from "./components/ViewLabTests";
import ViewReminders from "./components/ViewReminders";
import PatientSummaryNote from "./components/PatientSummaryNote";
import PrescriptionDashboard from "./components/PrescriptionDashboard";
import LeaveAlertsCards from "./components/LeaveAlertsTable";


function App() {
  return (
    <div className="App" >
      <BrowserRouter>
      <LanguageState>
        <Alert/>
        <SessionTimeoutPopup/>
        <Routes>
          <Route exact path="/" element={<FrontPage />} />
          <Route exact path="/login" element={<ParentLogin />} />
          <Route exact path="/signup" element={<Signup />} />
          <Route
            exact
            path="/otp"
            element={
              <Verify>
                <OtpVerify />
              </Verify>
            }
          />
          
          <Route exact path="/account" element={<Profile/>}/>
          <Route exact path="/ask/:id" element={<QuestionPage/>}></Route>
          <Route exact path="/warden-dashboard" element={<QuestionPage/>}></Route>
          <Route exact path="/medicine_chat" element={<MedicineChatBot/>}></Route>
          <Route exact path="/patient_summary_note" element={<PatientSummaryEntry/>}></Route>
          <Route exact path="/student-details" element={<WardenStudentDashboard/>}></Route>
          <Route exact path="/chat_history" element={<ChatHistory/>}></Route>
          <Route exact path="/view_appointment" element={<ViewAppointments/>}></Route>
          <Route exact path="/view_lab_test" element={<ViewLabTests/>}></Route>
          <Route exact path="/view_reminder" element={<ViewReminders/>}></Route>
          <Route exact path="/chat_summary" element={<PatientSummaryNote/>}></Route>
          <Route exact path="/prescription_history"  element={<PrescriptionDashboard/>}></Route>
          <Route exact path="view_leave_alerts" element={<LeaveAlertsCards/>}></Route>
          
          
          
        </Routes>
        </LanguageState>
      </BrowserRouter>
    </div>
  );
}

export default App;
